import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlpInvestigationB = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17735" data-mp="2l8cvvxaqaewf">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17736" data-mp="2uam24ayyrm40"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17737" data-mp="3901rbmiujjhl">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17738" data-mp="3924sn2pg8z1m">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17739" data-mp="33zvza58nzuyz">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17740" data-mp="3hydq4btv9nl4">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17741" data-mp="1nmyzlst17k4b">
          <div className="text-left" data-id="element-17742" data-mp="nldsrw8xf34t">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17743" data-mp="nmym5iji8g13">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17744" data-mp="17bfqfi9cjnaq">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17745" data-mp="1gb2s855zmv4b">
        <div className="max-w-4xl mx-auto" data-id="element-17746" data-mp="1l8vy0x3dpn42">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17747" data-mp="1l7t4eheo96kg">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17748" data-mp="3mzphvwkegqhv">
            Why Are So Many People on GLP-1 Getting Depressed—And Why Won't
            Anyone Talk About It?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17749" data-mp="3azsjsllclgom">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17750" data-mp="3oz0lbl4zh0vz">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17751" data-mp="3jy4kjgfxhuus" />
            </div>
            <div className="flex-1" data-id="element-17752" data-mp="3tw0uw611klru">
              <div className="flex items-center" data-id="element-17753" data-mp="3tuzfjpcztd4b">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17754" data-mp="bjcfh76iz7vz">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17755" data-mp="6krntw5c9wj5">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17756" data-mp="liboiqv7d5ji" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17757" data-mp="gi5vb69abazb">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17758" data-mp="103ft31z89xri">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17759" data-mp="144rib6e6wgz6">
                <div className="flex items-center mr-4" data-id="element-17760" data-mp="q4zz8r8tgaeb">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17761" data-mp="v4mdn40drwop" />
                  <span data-id="element-17762" data-mp="v3bczd28f51t">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17763" data-mp="gfq75bdz2rq7">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17764" data-mp="gdvm7x2pazm4" />
                  <span data-id="element-17765" data-mp="l7qe3nsgmkwa">31,542 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17766" data-mp="7ftopri6ep3l">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17767" data-mp="ceegd2jd40gf" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17768" data-mp="3tm8gb8vpz67z">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17769" data-mp="15quwrtn493ku">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting
            severe depression—and regulatory agencies ignored it—I decided to
            run a 16-month investigation. What I discovered will save you
            sleepless nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17770" data-mp="i1a9wznudm6a">
            <div className="mb-1 flex items-center" data-id="element-17771" data-mp="d38hvp8fucio">
              <span className="font-medium mr-2" data-id="element-17772" data-mp="83cglxr4kz6t">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17773" data-mp="27ff5jniiqlrv">
              <span className="font-medium mr-2" data-id="element-17774" data-mp="27e42jpwwdi1t">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-17775" data-mp="2oq2bbfnoj45u">
        <div className="max-w-4xl mx-auto" data-id="element-17776" data-mp="1r21yim146jjd">
          <div className="sm:flex items-center" data-id="element-17777" data-mp="1r33ixh40sidr">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-17778" data-mp="1w153y7l0arrv">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-17779" data-mp="1w1n8drhtocav" />
            </div>
            <div className="sm:w-2/3" data-id="element-17780" data-mp="260m7aicsctko">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17781" data-mp="3cfn56tldfltw">
                <span className="font-bold" data-id="element-17782" data-mp="3cf3o1f3jp1gx">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17783" data-mp="1qak8wm4ayrtb">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpInvestigationB;